/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-02 14:21:20
 * @Description:
 */

import type { 
    GameListResponseState,
    EMIT_GET_GAME_CONFIG_PARAMS,
    GAME_CONFIG_OBJ,
} from './dto';

export const useGameListSocket = () => {
    const rootPath = 'gamelist';

    /**
     * 查询游戏列表 
     * @param data 
     * @param callback 
     */
    const EMIT_GET_ORIGINAK_GAMES = (
        data: any,
        callback: (res: GameListResponseState) => any
    ) => {
        socket.emit(`${rootPath}.getOriginalGames`, data, (res)=>{
            res ||= [];
            if (res.sort){
                res.sort((aa, bb) => {
                    return aa.sort - bb.sort;
                });
            }else{
                // 因为真有遇到 .sort() 取不到方法的情况，所以添加判断  
                console.error('.getOriginalGames error', res); 
                res = []; // 覆盖错误值
            }
            // console.log('游戏列表(sort 排序)：', res); 
            callback(res);
        });
    };

    /**
     * 查询某个游戏的设定信息 (config)
     * 返回值与 .join 高度一致，返回游戏配置信息。但此接口不会使后台认为此用户加进入了游戏房间 
     * @param data 
     * @param callback 
     */
    const EMIT_GET_GAME_CONFIG = (
        data: EMIT_GET_GAME_CONFIG_PARAMS,
        callback: (res: GAME_CONFIG_OBJ) => any,
    ) => {
        socket.emit(
            `${rootPath}.getOriginalGameConfig`,
            data,
            callback,
        );
    };


    return {
        EMIT_GET_ORIGINAK_GAMES,
        EMIT_GET_GAME_CONFIG,
    };
};
